var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  Follow-up added to "+_vm._s(_vm.$lodash.get(_vm.activity, "detail.job.follow_up_to"))+" for Job Status\n  "+_vm._s(_vm.$lodash.get(_vm.activity, "detail.job.status"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }